import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NoResultsFoundComponent } from "@modules/+new/shared/components/no-results-found/no-results-found.component";
import { CoreModule } from "@modules/core/core.module";
import { UniversalModalModule } from "@modules/+new/shared/universal-modal/universal-modal.module";
import { A11yModule } from "@angular/cdk/a11y";

@NgModule({
	imports: [CommonModule, CoreModule, UniversalModalModule, A11yModule],
	declarations: [NoResultsFoundComponent],
	exports: [NoResultsFoundComponent, CommonModule, CoreModule, A11yModule]
})
export class SharedModule {}
